import { InStorage } from "./Storage"

export class InLocalStorage<T> extends InStorage<T> {
    constructor(key: string) {
        super(localStorage, key);
    }
}
export class InSessionStorage<T> extends InStorage<T> {
    constructor(key: string) {
        super(sessionStorage, key);
    }
}